import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';
import searchSlugsByCollection from '../../api/graphql/queries/searchSlugsByCollection';

class AutocompleteArray extends Component {
  state = {
    // The active selection's index
    activeSuggestion: 0,
    // The suggestions that match the user's input
    filteredSuggestions: [],
    // Whether or not the suggestion list is shown
    showSuggestions: false,
    // What the user has entered
    userInput: '',
    subArray: [],
  };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        userInput: value,
      });
    }
    return null;
  }

  onChange = async (e) => {
    const { suggestions, showVenues, name } = this.props;
    const userInput = e.currentTarget.value;

    if (suggestions && suggestions.length) {
      // Filter our suggestions that don't contain the user's input
      const filteredSuggestions = suggestions && suggestions.filter(suggestion => suggestion && suggestion.toLowerCase().indexOf(userInput && userInput.toLowerCase()) > -1);

      this.setState({
        activeSuggestion: 0,
        filteredSuggestions,
        showSuggestions: true,
        userInput,
      });
      if (filteredSuggestions && filteredSuggestions.length) {
        showVenues(true, '46');
      }
      if (userInput.length === 0) {
        showVenues(false, '16');
      }
      if (filteredSuggestions.length === 0) {
        showVenues(false, '24');
      }
    } else {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput,
      });
      if (userInput && userInput.length >= 4) {
        const searchSlugsResult = await searchSlugsByCollection(userInput, name);

        if (searchSlugsResult && searchSlugsResult.isAuth && searchSlugsResult.slugNames.length) {
          this.setState({
            activeSuggestion: 0,
            filteredSuggestions: searchSlugsResult.slugNames,
            showSuggestions: true,
            userInput,
          });
        } else {
          this.setState({
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: true,
            userInput,
          });
        }
      }
    }
  };

  onClick = (e) => {
    const { storeArray, name } = this.props;
    const { subArray } = this.state;
    const addingArray = [...subArray, e.currentTarget.innerText.toLowerCase()];
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: '',
      subArray: addingArray,
    });
    storeArray(name, e.currentTarget.innerText.toLowerCase());
  };

  render() {
    const {
      onChange,
      onClick,
      state: {
        activeSuggestion, filteredSuggestions, showSuggestions, userInput, subArray,
      },
    } = this;

    const {
      message, title, value, action, isLocked, textColor, map, suggestions,
    } = this.props;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions && filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-none mt-0 pl-0" style={{ overflowY: 'auto', width: 'calc(300px + 1 rem)' }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestion) {
                className = 'cursor-pointer';
              }

              return (
                <li className={`${className} p-2 uppercase hover:text-black hover:bg-white ${map && 'rounded-full'}`} key={suggestion} onClick={onClick}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions pt-1">
            <em>{message}</em>
          </div>
        );
      }
    } else if (suggestions.length === 0 && userInput && userInput.length < 4) {
      suggestionsListComponent = (
        <div className="no-suggestions pt-1">
          <em>Please provide at least 4 characters to search</em>
        </div>
      );
    }

    return (
      <Fragment>
        {(action === 'create' || action === 'modify') && (
          <div className={`flex flex-col font-americaMonoRegular text-xs uppercase ${map ? 'w-1/2 mb-1 max-h-180' : 'mb-2'}`}>
            <span className={`text-${textColor}`}>{title}</span>
            <input type="text" onChange={onChange} value={userInput} className={`mt-2 rounded-full border-1 p-2 bg-${isLocked ? 'grey' : 'white'} text-black outline-none`} disabled={isLocked} placeholder={suggestions && suggestions.length ? '' : 'enter at least 4 characters to search'} />
            {suggestionsListComponent}
          </div>
        )}
        {(action === 'display' || action === 'delete') && (
          <div className="flex flex-col font-americaMonoRegular text-xs uppercase">
            <span>{title}</span>
            <input type="text" value={value} className="rounded-full border-1 p-2 bg-grey text-black outline-none" disabled />
          </div>
        )}
      </Fragment>
    );
  }
}

AutocompleteArray.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  value: PropTypes.string,
  message: PropTypes.string.isRequired,
  storeArray: PropTypes.func.isRequired,
  isLocked: PropTypes.bool,
  textColor: PropTypes.string,
  map: PropTypes.bool,
  showVenues: PropTypes.func,
};

AutocompleteArray.defaultProps = {
  value: '',
  isLocked: false,
  suggestions: [],
  textColor: 'white',
  map: false,
  showVenues: () => { },
};

export default AutocompleteArray;
